import { ClientConfig } from '@goalsetter/classroom-types/auth-app';

const CLIENT_CONFIG_STORAGE_KEY = 'client_config';

export class ClientConfigHelper {
  /**
   * Get client configuration from localStorage
   * @returns ClientConfig | null
   */
  static getClientConfig(): ClientConfig | null {
    try {
      if (typeof window === 'undefined') {
        return null;
      }

      const storedConfig = localStorage.getItem(CLIENT_CONFIG_STORAGE_KEY);
      if (!storedConfig) {
        return null;
      }

      return JSON.parse(storedConfig) as ClientConfig;
    } catch (error) {
      console.error('Error getting client config from localStorage:', error);
      return null;
    }
  }

  /**
   * Save client configuration in localStorage
   * @param config ClientConfig
   */
  static saveClientConfig(config: ClientConfig): void {
    try {
      if (typeof window === 'undefined') {
        return;
      }
      localStorage.setItem(CLIENT_CONFIG_STORAGE_KEY, JSON.stringify(config));
    } catch (error) {
      console.error('Error setting client config in localStorage:', error);
    }
  }

  /**
   * Update specific client configuration in localStorage
   * @param updates Partial<ClientConfig>
   */
  static updateClientConfig(updates: Partial<ClientConfig>): void {
    try {
      const currentConfig = this.getClientConfig();
      if (!currentConfig) {
        console.warn(
          'No existing client config found. Use saveClientConfig instead.',
        );
        return;
      }

      const updatedConfig = { ...currentConfig, ...updates };
      this.saveClientConfig(updatedConfig);
    } catch (error) {
      console.error('Error updating user config:', error);
    }
  }

  /**
   * Clear client configuration from localStorage
   */
  static clearClientConfig(): void {
    try {
      if (typeof window === 'undefined') {
        return;
      }

      localStorage.removeItem(CLIENT_CONFIG_STORAGE_KEY);
    } catch (error) {
      console.error('Error clearing client config from localStorage:', error);
    }
  }
}
